module.exports = __webpack_public_path__ + "static/media/Youth.5b18c34f.jpg";